(function() {

  /* ── Load jsPDF ─────────────────────────────────────────────── */
  if (!window._jsPDFLoading) {
    window._jsPDFLoading = true;
    window._jsPDFLoaded  = false;
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
    s.onload  = function() { window._jsPDFLoaded = true; };
    s.onerror = function() { console.error('[AussieSwings] Failed to load jsPDF'); };
    document.head.appendChild(s);
  }

  /* ── Brand ──────────────────────────────────────────────────── */
  var B = {
    name:    'Aussie Swings',
    tagline: 'Manufactured in Australia',
    green:   [0, 171, 0],
    lgreen:  [216, 255, 196],
    dark:    [26, 26, 26],
    mid:     [70, 70, 70],
    lite:    [245, 248, 245],
    white:   [255, 255, 255],
    addr:    '12 Dundee Avenue Holden Hill South Australia 5088',
    phone:   '08-83675003',
    email:   'sales@aussieswings.com.au',
    logo:    'https://rn9bhn-q0.myshopify.com/cdn/shop/files/aussie_swings_logo_large_21c66b51-8956-4b0e-85c8-1b10d6a74792_260x.png'
  };

  /* ── PDF helpers ─────────────────────────────────────────────── */
  function sf(doc, c) { doc.setFillColor(c[0], c[1], c[2]); }
  function sd(doc, c) { doc.setDrawColor(c[0], c[1], c[2]); }
  function st(doc, c) { doc.setTextColor(c[0], c[1], c[2]); }

  function wrapped(doc, text, x, y, w, lh) {
    if (!text) return y;
    text.split('\n').forEach(function(para) {
      para = para.trim();
      if (!para) { y += lh * 0.4; return; }
      doc.splitTextToSize(para, w).forEach(function(line) {
        doc.text(line, x, y); y += lh;
      });
    });
    return y;
  }

  function newPageHeader(doc, title) {
    sf(doc, B.green);  doc.rect(0, 0, 210, 14, 'F');
    sf(doc, B.lgreen); doc.rect(0, 14, 210, 3, 'F');
    doc.setFont('helvetica', 'bold'); doc.setFontSize(8);
    st(doc, B.white);
    doc.text(B.name + '  —  ' + title, 14, 10);
    return 22;
  }

  function checkPage(doc, y, needed, title) {
    if (y + needed > 268) { doc.addPage(); return newPageHeader(doc, title); }
    return y;
  }

  /* ── Rich text parser ───────────────────────────────────────── */
  function parseRichText(raw) {
    if (!raw) return '';
    var s = raw.trim();
    if (s.charAt(0) !== '{') return s;
    try { return extractNodes(JSON.parse(s)).trim(); }
    catch(e) {
      return s.replace(/\{"type":"[a-z\-]+",/g,' ')
        .replace(/"(type|value|children|bold|listType)":/g,'')
        .replace(/:(true|false|"[a-z\-]+")/g,'')
        .replace(/[{}\[\]"]/g,'')
        .replace(/\s{2,}/g,' ').trim();
    }
  }

  function extractNodes(node) {
    if (!node) return '';
    if (node.type === 'text') return node.value || '';
    var out = '';
    if (Array.isArray(node.children)) {
      node.children.forEach(function(c) { out += extractNodes(c); });
    }
    if (node.type === 'paragraph' || node.type === 'list-item') out += '\n';
    if (node.type === 'list') out += '\n';
    return out;
  }

  /* ── Image loaders ──────────────────────────────────────────── */
  function loadImg(url, cb) {
    var img = new Image(); img.crossOrigin = 'Anonymous';
    img.onload = function() {
      try {
        var c = document.createElement('canvas');
        c.width = img.width; c.height = img.height;
        var ctx = c.getContext('2d');
        ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, c.width, c.height);
        ctx.drawImage(img, 0, 0);
        cb(c.toDataURL('image/jpeg', 0.92), img.width, img.height);
      } catch(e) { cb(null, 0, 0); }
    };
    img.onerror = function() { cb(null, 0, 0); };
    img.src = url + (url.indexOf('?') < 0 ? '?' : '&') + '_t=' + Date.now();
  }

  function loadLogoPNG(url, cb) {
    var img = new Image(); img.crossOrigin = 'Anonymous';
    img.onload = function() {
      try {
        var c = document.createElement('canvas');
        c.width = img.width; c.height = img.height;
        c.getContext('2d').drawImage(img, 0, 0);
        cb(c.toDataURL('image/png'), img.width, img.height);
      } catch(e) { cb(null, 0, 0); }
    };
    img.onerror = function() { cb(null, 0, 0); };
    img.src = url + (url.indexOf('?') < 0 ? '?' : '&') + '_t=' + Date.now();
  }

  function loadAll(urls, cb) {
    if (!urls || !urls.length) { cb([]); return; }
    var res = new Array(urls.length), done = 0;
    urls.forEach(function(url, i) {
      loadImg(url, function(d, w, h) {
        res[i] = { data: d, w: w, h: h };
        if (++done === urls.length) cb(res);
      });
    });
  }

  /* ── generate() ─────────────────────────────────────────────── */
  function generate() {
    var btn = document.getElementById('btn-download-catalogue');
    var lbl = document.getElementById('btn-catalogue-label');

    /* Wait for jsPDF if not ready yet */
    if (!window._jsPDFLoaded || typeof window.jspdf === 'undefined' || !window.jspdf.jsPDF) {
      if (lbl) lbl.textContent = 'Loading…';
      if (btn) btn.disabled = true;
      var attempts = 0;
      var wait = setInterval(function() {
        attempts++;
        if (window._jsPDFLoaded && typeof window.jspdf !== 'undefined' && window.jspdf.jsPDF) {
          clearInterval(wait);
          if (lbl) lbl.textContent = 'Download Catalogue';
          if (btn) btn.disabled = false;
          generate();
        } else if (attempts > 20) {
          clearInterval(wait);
          if (lbl) lbl.textContent = 'Download Catalogue';
          if (btn) btn.disabled = false;
          alert('Could not load PDF library. Please check your connection and try again.');
        }
      }, 300);
      return;
    }

    var el = document.getElementById('catalogue-data');
    if (!el) { alert('Product data not found.'); return; }

    /* Read price from live DOM */
    var priceText = '';
    var priceSelectors = [
      '.productView-price .price-item--regular',
      '.productView-price .price__regular .price-item',
      '.product-price .price-item--regular',
      '.price-item--regular',
      '.price__regular',
      '[data-product-price]',
      '.price .money',
      '.money'
    ];
    for (var i = 0; i < priceSelectors.length; i++) {
      var node = document.querySelector(priceSelectors[i]);
      if (node && node.textContent.trim()) {
        priceText = node.textContent.trim();
        break;
      }
    }

    var data = {
      title:       el.dataset.title       || '',
      handle:      el.dataset.handle      || '',
      price:       priceText              || '',
      description: parseRichText(el.dataset.description  || ''),
      sku:         el.dataset.sku         || '',
      type:        el.dataset.type        || '',
      vendor:      el.dataset.vendor      || '',
      url:         el.dataset.url         || '',
      shortDesc:   parseRichText(el.dataset.mfShortDesc   || ''),
      descTitle:   parseRichText(el.dataset.mfDescTitle   || '') || 'Description',
      descContent: parseRichText(el.dataset.mfDescContent || ''),
      infoTitle:   parseRichText(el.dataset.mfInfoTitle   || '') || 'Additional Information',
      infoContent: parseRichText(el.dataset.mfInfoContent || '')
    };

    var imageUrls = [];
    try { imageUrls = JSON.parse(el.dataset.images || '[]'); } catch(e) {}
    imageUrls = imageUrls.filter(function(u) { return u && u.length > 0; });

    if (btn) btn.disabled = true;
    if (lbl) lbl.textContent = 'Generating PDF…';

    loadLogoPNG(B.logo, function(logoData, logoW, logoH) {
      loadAll(imageUrls, function(imgResults) {
        try { buildPDF(data, logoData, logoW, logoH, imgResults); }
        catch(err) { console.error(err); alert('PDF error: ' + err.message); }
        if (btn) btn.disabled = false;
        if (lbl) lbl.textContent = 'Download Catalogue';
      });
    });
  }

  /* ── buildPDF() ─────────────────────────────────────────────── */
  function buildPDF(data, logoData, logoW, logoH, imgs) {
    var doc = new window.jspdf.jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
    var PW = 210, PH = 297, M = 14, CW = PW - M * 2;

    /* ── HEADER ───────────────────────────────────────────────── */
    var HH = 24;
    sf(doc, B.green); doc.rect(0, 0, PW, HH, 'F');

    if (logoData && logoW > 0) {
      var ldH = HH - 8;
      var ldW = (logoW / logoH) * ldH;
      if (ldW > 36) { ldW = 36; ldH = (logoH / logoW) * ldW; }
      doc.addImage(logoData, 'PNG', M, (HH - ldH) / 2, ldW, ldH);
    } else {
      doc.setFont('helvetica', 'bold'); doc.setFontSize(11);
      st(doc, B.white); doc.text(B.name, M, HH / 2 + 2);
    }

    doc.setFont('helvetica', 'italic'); doc.setFontSize(7.5);
    st(doc, B.white); doc.text(B.tagline, PW - M, HH / 2 + 2, { align: 'right' });
    sf(doc, B.lgreen); doc.rect(0, HH, PW, 3, 'F');

    /* ── TITLE + PRICE ────────────────────────────────────────── */
    var tY = HH + 5, tH = 12;
    sf(doc, B.lite); doc.rect(0, tY, PW, tH, 'F');

    var priceW = 0;
    if (data.price) {
      doc.setFont('helvetica', 'bold'); doc.setFontSize(11);
      priceW = doc.getTextWidth(data.price) + 10;
      sf(doc, B.green);
      doc.roundedRect(PW - M - priceW, tY, priceW, tH, 2, 2, 'F');
      st(doc, B.white);
      doc.text(data.price, PW - M - 5, tY + tH / 2 + 2, { align: 'right' });
    }

    doc.setFont('helvetica', 'bold'); doc.setFontSize(13);
    st(doc, B.dark);
    var maxTW = CW - priceW - 10;
    var tt = data.title;
    while (tt.length > 0 && doc.getTextWidth(tt) > maxTW) tt = tt.slice(0, -1);
    if (tt !== data.title) tt += '\u2026';
    doc.text(tt, M + 4, tY + tH / 2 + 2);

    /* ── TWO COLUMNS ──────────────────────────────────────────── */
    var y    = tY + tH + 5;
    var colL = M, colR = M + CW * 0.46 + 5;
    var colLW = CW * 0.46, colRW = CW * 0.51;

    /* Right: overview + details */
    var ry = y;
    if (data.shortDesc) {
      doc.setFont('helvetica', 'bold'); doc.setFontSize(9); st(doc, B.green);
      doc.text('OVERVIEW', colR, ry);
      sd(doc, B.green); doc.setLineWidth(0.4);
      doc.line(colR, ry + 1.5, colR + colRW, ry + 1.5);
      ry += 5.5;
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); st(doc, B.mid);
      ry = wrapped(doc, data.shortDesc, colR, ry, colRW, 4.8) + 5;
    }

    var meta = [];
    if (data.sku)    meta.push(['SKU',          data.sku]);
    if (data.type)   meta.push(['Product Type', data.type]);
    if (data.vendor) meta.push(['Vendor',        data.vendor]);

    if (meta.length) {
      doc.setFont('helvetica', 'bold'); doc.setFontSize(9); st(doc, B.green);
      doc.text('PRODUCT DETAILS', colR, ry);
      sd(doc, B.green); doc.setLineWidth(0.4);
      doc.line(colR, ry + 1.5, colR + colRW, ry + 1.5);
      ry += 6;
      meta.forEach(function(row) {
        doc.setFont('helvetica', 'bold'); doc.setFontSize(8.5); st(doc, B.dark);
        doc.text(row[0] + ':', colR, ry);
        doc.setFont('helvetica', 'normal'); st(doc, B.mid);
        doc.text(row[1], colR + 30, ry);
        ry += 5.5;
      });
    }

    /* Left: image grid */
    var valid = imgs.filter(function(i) { return i && i.data; });
    var ic = valid.length, imgEndY = y;

    if (ic === 0) {
      sf(doc, [240,245,240]); sd(doc, [200,220,200]);
      doc.setLineWidth(0.3); doc.roundedRect(colL, y, colLW, 58, 2, 2, 'FD');
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8); st(doc, [160,180,160]);
      doc.text('No image', colL + colLW / 2, y + 31, { align: 'center' });
      imgEndY = y + 58;
    } else if (ic === 1) {
      var ih = 60;
      sf(doc, [248,250,248]); sd(doc, [210,230,210]);
      doc.setLineWidth(0.3); doc.roundedRect(colL, y, colLW, ih, 2, 2, 'FD');
      var im = valid[0], asp = im.h > 0 ? im.w / im.h : 1;
      var fw = colLW - 6, fh = fw / asp;
      if (fh > ih - 6) { fh = ih - 6; fw = fh * asp; }
      doc.addImage(im.data, 'JPEG', colL + (colLW - fw) / 2, y + (ih - fh) / 2, fw, fh);
      imgEndY = y + ih;
    } else {
      var grid = valid.slice(0, 6);
      var bW = (colLW - 3) / 2, bH = bW * 0.85;
      grid.forEach(function(im, idx) {
        var col = idx % 2, row = Math.floor(idx / 2);
        var bx = colL + col * (bW + 3), by = y + row * (bH + 3);
        sf(doc, [248,250,248]); sd(doc, [210,230,210]);
        doc.setLineWidth(0.3); doc.roundedRect(bx, by, bW, bH, 2, 2, 'FD');
        if (im && im.data) {
          var a = im.h > 0 ? im.w / im.h : 1;
          var fw = bW - 5, fh = fw / a;
          if (fh > bH - 5) { fh = bH - 5; fw = fh * a; }
          doc.addImage(im.data, 'JPEG', bx + (bW - fw) / 2, by + (bH - fh) / 2, fw, fh);
        }
      });
      imgEndY = y + Math.ceil(grid.length / 2) * (bH + 3) - 3;
    }

    y = Math.max(imgEndY, ry) + 4;

    /* ── DIVIDER ──────────────────────────────────────────────── */
    sf(doc, B.lgreen); doc.rect(M, y, CW, 1, 'F');
    y += 7;

    /* ── DESCRIPTION ──────────────────────────────────────────── */
    var descText = data.descContent || data.description || '';
    if (descText) {
      y = checkPage(doc, y, 18, data.title);
      sf(doc, B.dark); doc.rect(M, y, CW, 8, 'F');
      doc.setFont('helvetica', 'bold'); doc.setFontSize(9); st(doc, B.white);
      doc.text(data.descTitle.toUpperCase(), M + 4, y + 5.5);
      y += 14;
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9); st(doc, B.mid);
      descText.split('\n').forEach(function(para) {
        para = para.trim(); if (!para) { y += 2; return; }
        y = checkPage(doc, y, 8, data.title);
        doc.splitTextToSize(para, CW).forEach(function(line) {
          y = checkPage(doc, y, 6, data.title);
          doc.text(line, M, y); y += 5.2;
        });
      });
      y += 7;
    }

    /* ── ADDITIONAL INFORMATION ───────────────────────────────── */
    if (data.infoContent) {
      y = checkPage(doc, y, 18, data.title);
      sf(doc, B.green); doc.rect(M, y, CW, 8, 'F');
      doc.setFont('helvetica', 'bold'); doc.setFontSize(9); st(doc, B.white);
      doc.text(data.infoTitle.toUpperCase(), M + 4, y + 5.5);
      y += 14;
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9); st(doc, B.mid);
      data.infoContent.split('\n').forEach(function(para) {
        para = para.trim(); if (!para) { y += 2; return; }
        y = checkPage(doc, y, 8, data.title);
        doc.splitTextToSize(para, CW).forEach(function(line) {
          y = checkPage(doc, y, 6, data.title);
          doc.text(line, M, y); y += 5.2;
        });
      });
    }

    /* ── FOOTER on every page ─────────────────────────────────── */
    var total = doc.internal.getNumberOfPages();
    for (var p = 1; p <= total; p++) {
      doc.setPage(p);
      var fy = PH - 22;
      sf(doc, B.green); doc.rect(0, fy, PW, 22, 'F');
      doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5); st(doc, B.white);
      doc.text(B.addr,           M, fy + 6);
      doc.text('Ph: ' + B.phone, M, fy + 11.5);
      doc.text(B.email,          M, fy + 17);
      doc.setFont('helvetica', 'italic'); doc.setFontSize(7); st(doc, B.lgreen);
      var ds = new Date().toLocaleDateString('en-AU', { day: '2-digit', month: 'long', year: 'numeric' });
      doc.text('Generated: ' + ds, PW - M, fy + 11.5, { align: 'right' });
      doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5); st(doc, B.white);
      doc.text(B.name.toUpperCase(), PW / 2, fy + 18, { align: 'center' });
    }

    /* ── OUTPUT: download with correct filename ──────────────── */
    var handle   = (data.handle || data.title).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    var filename = handle + '-catalogue.pdf';
    doc.save(filename);
  }

  /* ── Expose globally ─────────────────────────────────────────── */
  window.AussieSwingsPDF = { generate: generate };

})();